firebird.directive('camaroDetector', [
    'templateCache',
    function (templateCache) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate('camaroDetector.html'), // for non-redesign only
            link: function (scope, element, attrs, ngCtrl) {}
        };
    }
]);
